module.exports = __webpack_public_path__ + "static/media/Rectangle200.2a6d1322.png";